/**
 * Shopify variant image position grouping.
 * Images from a variant's featured media through the next variant's featured media
 * belong to that variant (Shopify admin media order).
 */
(function () {
  function buildVariantMediaMap(data) {
    const mediaIds = data.mediaIds || [];
    const variants = data.variants || [];
    const map = {};

    variants.forEach((variant) => {
      const variantId = variant.id;
      const featuredMediaId = variant.featuredMediaId;

      if (!featuredMediaId) {
        map[variantId] = mediaIds.slice();
        return;
      }

      const startIdx = mediaIds.indexOf(featuredMediaId);
      if (startIdx < 0) {
        map[variantId] = [featuredMediaId];
        return;
      }

      let endIdx = mediaIds.length;
      variants.forEach((other) => {
        if (other.id === variantId || !other.featuredMediaId) return;
        const otherIdx = mediaIds.indexOf(other.featuredMediaId);
        if (otherIdx > startIdx && otherIdx < endIdx) endIdx = otherIdx;
      });

      map[variantId] = mediaIds.slice(startIdx, endIdx);
    });

    return map;
  }

  function getMediaIdsForVariant(variantId, data) {
    if (!data) return [];
    if (!data._map) data._map = buildVariantMediaMap(data);
    const id = parseInt(variantId, 10);
    return data._map[id] || data._map[String(id)] || data.mediaIds || [];
  }

  function parseMapFromElement(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  window.VariantMediaGroups = {
    buildVariantMediaMap,
    getMediaIdsForVariant,
    parseMapFromElement,
  };
})();
